import type { ExpertiseItem } from '@/types';

export const expertise: ExpertiseItem[] = [
  {
    id: 'backend-api',
    title: 'Backend & API Development',
    description:
      'Build and maintain .NET Core services and portals using layered architecture, repositories, CQRS, MediatR, messaging, and search where the product needs them.',
  },
  {
    id: 'fullstack-web',
    title: 'Full-Stack Web Applications',
    description:
      'Deliver web products that connect solid backend foundations with Angular frontends, with attention to maintainability and clear delivery through the full lifecycle.',
  },
  {
    id: 'mobile-apps',
    title: 'Mobile Application Development',
    description:
      'Ship Android, iOS, and Flutter experiences with maps, notifications, REST clients, and practical testing on devices and emulators.',
  },
  {
    id: 'modernization',
    title: 'Architecture & System Improvement',
    description:
      'Apply patterns such as N-tier design, CQRS, and mediators to keep growing codebases easier to test, extend, and operate.',
  },
  {
    id: 'integration',
    title: 'Technical Integration',
    description:
      'Connect applications with REST APIs, SignalR, RabbitMQ, Elasticsearch, maps/platform SDKs, and DevOps tooling used in production environments.',
  },
];
